(function () {
  var root = document.getElementById('cs-gift');
  var dataEl = document.getElementById('cs-gift-data');
  if (!root || !dataEl) return;

  var occasions = [];
  try { occasions = JSON.parse(dataEl.textContent || '[]'); } catch (e) { return; }

  var params = new URLSearchParams(window.location.search);
  var preview = params.get('cs_gift_preview');
  var country = root.getAttribute('data-country') || '';
  var code = root.getAttribute('data-code') || '';
  var delay = Math.max(5, parseInt(root.getAttribute('data-delay'), 10) || 20) * 1000;
  var PENDING = 'cs_gift_pending';
  var SIGNED = 'cs_gift_signed_up';
  var DISMISSED = 'cs_gift_dismissed';

  function ls(k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      if (v === null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function ss(k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      if (v === null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  var loadedAt = Date.now();
  var triggerType = '';
  var openedAt = 0;
  function pageType() {
    if (document.querySelector('.cs-fyc')) return 'find_my_clan';
    return root.getAttribute('data-template') || 'other';
  }
  function scrollPct() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    return h > 0 ? Math.round(100 * window.scrollY / h) : 0;
  }
  function publish(name, data) {
    data.page_type = pageType();
    data.device = window.matchMedia('(min-width: 750px)').matches ? 'desktop' : 'mobile';
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data);
    } catch (e) {}
    try {
      var cp = window.Shopify && Shopify.customerPrivacy;
      var ok = cp && typeof cp.analyticsProcessingAllowed === 'function' ? cp.analyticsProcessingAllowed() : false;
      if (ok && typeof window.clarity === 'function') {
        window.clarity('event', name);
        if (data.occasion) window.clarity('set', 'gift_popup', data.occasion);
        if (data.trigger) window.clarity('set', 'gift_popup_trigger', data.trigger);
      }
    } catch (e) {}
  }

  function parseDay(s, endOfDay) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s || '').trim());
    if (!m) return null;
    return endOfDay ? new Date(+m[1], +m[2] - 1, +m[3], 23, 59, 59) : new Date(+m[1], +m[2] - 1, +m[3], 0, 0, 0);
  }
  function niceDate(s, short) {
    var d = parseDay(s, false);
    if (!d) return '';
    try { return d.toLocaleDateString('en-GB', short ? { weekday: 'short', day: 'numeric', month: 'short' } : { weekday: 'long', day: 'numeric', month: 'long' }); } catch (e) { return s; }
  }

  function pickOccasion() {
    if (preview) {
      for (var i = 0; i < occasions.length; i++) if (occasions[i].id === preview) return occasions[i];
    }
    var now = new Date();
    var live = occasions.filter(function (o) {
      var a = parseDay(o.start, false), b = parseDay(o.stop || o.end, true);
      return a && b && now >= a && now <= b;
    });
    live.sort(function (x, y) { return parseDay(x.stop || x.end, true) - parseDay(y.stop || y.end, true); });
    return live[0] || null;
  }

  if (!preview && /email/i.test(params.get('utm_medium') || '')) ls(SIGNED, '1');
  var occ = pickOccasion();
  var pending = null;
  try { pending = JSON.parse(ss(PENDING) || 'null'); } catch (e) {}
  if (pending && Date.now() - pending.at > 30 * 60 * 1000) pending = null;

  var navUrl = '';
  try { var nav = performance.getEntriesByType('navigation')[0]; navUrl = nav ? nav.name : ''; } catch (e) {}
  var posted = /customer_posted=true/.test(window.location.search) || /customer_posted=true/.test(navUrl);
  var errorMarker = root.querySelector('[data-cs-gift-status="error"]');

  if (pending && !occ) {
    for (var j = 0; j < occasions.length; j++) if (occasions[j].id === pending.occ) occ = occasions[j];
  }
  if (!occ) return;

  var clan = '';
  var isFyc = !!document.querySelector('.cs-fyc');

  function render() {
    var title = (clan && occ.titleClan) ? occ.titleClan.replace(/\[clan\]/g, clan) : occ.title;
    var cutoff = parseDay(occ.end, true);
    var late = cutoff && new Date() > cutoff && params.get('cs_gift_late') !== '0' || params.get('cs_gift_late') === '1';
    var line = late ? (occ.lateLine || '') : (occ.dateLine || '');
    var dateText = line.replace(/\[date\]/g, niceDate(occ.end, !window.matchMedia('(min-width: 750px)').matches));
    if (occ.accent) root.style.setProperty('--cs-gift-accent', occ.accent);
    var panel = params.get('cs_gift_panel') || occ.panel || 'stone';
    root.classList.toggle('cs-gift--red', panel === 'red');
    root.querySelector('[data-cs-gift-label]').textContent = occ.label || '';
    root.querySelector('[data-cs-gift-title]').textContent = title || '';
    root.querySelector('[data-cs-gift-body]').textContent = (clan && occ.bodyClan) ? occ.bodyClan.replace(/\[clan\]/g, clan) : (occ.body || '');
    root.querySelectorAll('[data-cs-gift-date]').forEach(function (n) { n.textContent = dateText; });
    root.querySelector('[data-cs-gift-code]').textContent = occ.code || code;
    if (occ.button) root.querySelector('[data-cs-gift-submit]').textContent = occ.button;
    if (occ.success) root.querySelector('[data-cs-gift-success]').textContent = occ.success;
    var media = root.querySelector('[data-cs-gift-media]');
    if (occ.img && !media.firstChild) {
      var img = new Image();
      img.src = occ.img;
      img.alt = occ.imgAlt || '';
      img.style.objectPosition = occ.focal || '50% 50%';
      media.appendChild(img);
    }
  }

  var lastFocus = null;
  var isOpen = false;
  function open(step) {
    if (isOpen) return;
    isOpen = true;
    render();
    root.querySelector('[data-step="form"]').hidden = step === 'done';
    root.querySelector('[data-step="done"]').hidden = step !== 'done';
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.addEventListener('keydown', onKey);
    setTimeout(function () {
      var f = step === 'done' ? root.querySelector('[data-cs-gift-copy]') : root.querySelector('#cs-gift-email');
      try { if (f && window.matchMedia('(min-width: 750px)').matches) f.focus(); } catch (e) {}
    }, 360);
    openedAt = Date.now();
    if (step !== 'done') publish('gift_popup_view', { occasion: occ.id, country: country, clan: clan, trigger: triggerType || 'preview', seconds_on_page: Math.round((openedAt - loadedAt) / 1000), scroll_pct: scrollPct() });
  }
  function close(dismissed) {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { root.hidden = true; }, 300);
    isOpen = false;
    if (dismissed && !preview) {
      var d = {};
      try { d = JSON.parse(ls(DISMISSED) || '{}'); } catch (e) {}
      d[occ.id] = Date.now();
      ls(DISMISSED, JSON.stringify(d));
      publish('gift_popup_dismiss', { occasion: occ.id, country: country, trigger: triggerType, seconds_open: Math.round((Date.now() - openedAt) / 1000) });
    }
    try { if (lastFocus) lastFocus.focus(); } catch (e) {}
  }
  function onKey(e) {
    if (e.key === 'Escape') close(root.querySelector('[data-step="done"]').hidden);
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(root.querySelectorAll('button, input:not([type="hidden"]), a[href]'), function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  }
  root.querySelectorAll('[data-cs-gift-close]').forEach(function (b) {
    b.addEventListener('click', function () { close(root.querySelector('[data-step="done"]').hidden); });
  });

  var copyBtn = root.querySelector('[data-cs-gift-copy]');
  copyBtn.addEventListener('click', function () {
    var done = function () { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2000); };
    try { navigator.clipboard.writeText(occ.code || code).then(done, done); } catch (e) { done(); }
  });

  var form = document.getElementById('cs-gift-form');
  var note = root.querySelector('[data-cs-gift-note]');
  var typoMap = { 'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmail.co': 'gmail.com', 'gamil.com': 'gmail.com',
    'gnail.com': 'gmail.com', 'gmail.con': 'gmail.com', 'hotmial.com': 'hotmail.com', 'hotmail.con': 'hotmail.com',
    'hotmal.com': 'hotmail.com', 'yahooo.com': 'yahoo.com', 'yaho.com': 'yahoo.com', 'yahoo.con': 'yahoo.com',
    'outlok.com': 'outlook.com', 'outlook.con': 'outlook.com', 'iclod.com': 'icloud.com', 'icloud.con': 'icloud.com',
    'btinternet.con': 'btinternet.com', 'aol.con': 'aol.com', 'comcast.con': 'comcast.net' };
  var typoChecked = '';
  var sending = false;
  function showNote(t) { note.textContent = t; note.hidden = false; }
  function tagSafe(s) { return String(s || '').replace(/[,]/g, ' ').replace(/[^A-Za-z0-9 '\-]/g, '').trim().slice(0, 40); }

  function prepare(event) {
    var field = form.querySelector('input[type="email"]');
    var value = field.value.trim();
    var domain = value.split('@')[1] ? value.split('@')[1].toLowerCase() : '';
    if (typoMap[domain] && typoChecked !== value) {
      event.preventDefault(); event.stopImmediatePropagation();
      var fixed = value.split('@')[0] + '@' + typoMap[domain];
      field.value = fixed; typoChecked = fixed;
      showNote('Did you mean ' + fixed + '? We’ve corrected it. Press the button again to sign up.');
      return false;
    }
    if (value.length > 100) {
      event.preventDefault(); event.stopImmediatePropagation();
      showNote('That email address looks too long. Please check it and try again.');
      return false;
    }
    var tags = ['newsletter', 'gift-popup', 'gift-' + tagSafe(occ.id), 'country-' + country];
    if (clan) tags.push('fyc-clan ' + tagSafe(clan));
    form.querySelector('[name="contact[tags]"]').value = tags.join(', ');
    ss('cs_fyc_signup', null);
    ss(PENDING, JSON.stringify({ occ: occ.id, clan: clan, trigger: triggerType, secs: Math.round((Date.now() - openedAt) / 1000), at: Date.now() }));
    return true;
  }
  form.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button');
    if (!button || !form.contains(button)) return;
    var field = form.querySelector('input[type="email"]');
    if (field && !field.checkValidity()) return;
    if (!prepare(event)) return;
    if (!sending) {
      sending = true;
      setTimeout(function () { button.disabled = false; button.style.pointerEvents = 'none'; button.style.opacity = '0.75'; button.textContent = 'Sending…'; }, 0);
    }
  }, true);
  form.addEventListener('submit', function (event) { prepare(event); }, true);

  function cleanUrl() {
    try {
      var u = new URL(window.location.href);
      if (!u.searchParams.has('customer_posted')) return;
      u.searchParams.delete('customer_posted');
      history.replaceState(history.state, '', u.pathname + u.search + (u.hash === '#cs-gift-form' ? '' : u.hash));
    } catch (e) {}
  }

  if (pending) {
    ss(PENDING, null);
    clan = pending.clan || '';
    if (posted && !errorMarker) {
      var first = ls(SIGNED) !== '1' && ls('cs_fyc_signed_up') !== '1';
      ls(SIGNED, '1');
      root.querySelector('[data-cs-gift-first]').hidden = !first;
      cleanUrl();
      open('done');
      publish('gift_popup_signup', { occasion: occ.id, country: country, clan: clan, status: 'saved', trigger: pending.trigger || '', seconds_open: pending.secs || 0 });
      return;
    }
    if (errorMarker) {
      cleanUrl();
      open('form');
      showNote('Sorry, that didn’t go through. Please check the email address and try again.');
      publish('gift_popup_signup', { occasion: occ.id, country: country, status: 'error' });
      return;
    }
  }

  if (!preview) {
    if (ls(SIGNED) === '1' || ls('cs_fyc_signed_up') === '1') return;
    var dismissed = {};
    try { dismissed = JSON.parse(ls(DISMISSED) || '{}'); } catch (e) {}
    if (dismissed[occ.id]) return;
  }

  var shown = false;
  function trigger(type) {
    if (shown) return;
    triggerType = type || 'timer';
    shown = true;
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onExit);
    open('form');
  }

  function clanFor(query) {
    try {
      if (typeof clanData === 'undefined' || !clanData || !clanData.surname_lookup) return '';
      var key = String(query || '').trim().toLowerCase();
      var names = clanData.surname_lookup[key] || [];
      if (!names.length && typeof cleanSearchInput === 'function') names = clanData.surname_lookup[cleanSearchInput(query)] || [];
      if (!names.length) return '';
      var c = typeof lookupClan === 'function' ? lookupClan(names[0]) : null;
      return c && c.name ? String(c.name).replace(/^Clan\s+/i, '') : '';
    } catch (e) { return ''; }
  }

  if (preview) {
    setTimeout(function () { if (isFyc && params.get('q')) clan = clanFor(params.get('q')); trigger('preview'); }, isFyc ? 4000 : 600);
    return;
  }

  var template = root.getAttribute('data-template') || '';
  var started = Date.now();
  var desktop = window.matchMedia('(min-width: 750px)').matches;

  function scrolledTo(pct) {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    return h > 0 && window.scrollY / h >= pct;
  }
  var exitArmed = false;
  setTimeout(function () { exitArmed = true; }, 10000);
  function onExit(e) {
    if (exitArmed && desktop && !e.relatedTarget && e.clientY <= 0) trigger('exit_intent');
  }
  document.addEventListener('mouseout', onExit);

  if (isFyc) {
    var closingSeen = false;
    var watch = function () {
      var end = document.querySelector('.cs-fyc .story-closing, .cs-fyc .closing-signup, .cs-fyc .no-match-signup');
      if (!end || closingSeen || !('IntersectionObserver' in window)) return;
      closingSeen = true;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { io.disconnect(); setTimeout(function () { trigger('story_end'); }, 2500); }
        });
      }, { threshold: 0.4 });
      io.observe(end);
    };
    var onSearch = function (q) {
      var c = clanFor(q);
      if (c) clan = c;
      closingSeen = false;
      setTimeout(watch, 1200);
    };
    if (typeof window.performSearch === 'function') {
      var orig = window.performSearch;
      window.performSearch = function (q) {
        var r = orig.apply(this, arguments);
        try { onSearch(q || (document.querySelector('.cs-fyc input[type="text"], .cs-fyc input[type="search"]') || {}).value); } catch (e) {}
        return r;
      };
    }
    var q0 = params.get('q');
    if (q0) setTimeout(function () { onSearch(q0); }, 1500);
    window.addEventListener('scroll', function () { if (clan && scrolledTo(0.8)) trigger('scroll_80'); }, { passive: true });
    return;
  }

  var depth = template === 'article' ? 0.6 : 0.5;
  function onScroll() {
    if (scrolledTo(depth) && Date.now() - started > 8000) trigger('scroll_' + Math.round(depth * 100));
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  if (template !== 'article') setTimeout(function () { trigger('timer_' + Math.round(delay / 1000) + 's'); }, delay);
})();
